<section class="row registrationView" id="productList-area">
  <section class="col-md-12 col-sm-6 pay-section float-left account-reg-section">

    @if (header == 'accountInformation') {
      <app-account-information [formDetails]="formData"></app-account-information>
    }

    @if (header == 'userInformation') {
      <app-user-information [formDetails]="formData" [isLoggedIn]="isLoggedIn"></app-user-information>
    }

  </section>
</section>
